export const categories = [
    {
        id: 1,
        name: 'frettir'
    }, {
        id: 2,
        name: 'vidburdir'
    }, {
        id: 3,
        name: 'reynsluakstur'
    }
]